import {
  CLEAR_SEARCH,
  SEARCH_ITEMS,
  SEARCH_RESTAURANTS,
  CLEAR_ITEM_SEARCH,
  SAVE_SEARCH_QUERY,
  SAVE_SELECTED_FILTER,
  SAVE_SEARCH_MODE,
  SAVE_SCROLL_POSITION,
  SAVE_FILTER_SCROLL_POSITION,
} from "./actionTypes";

const initialState = {
  restaurants: [],
  searchItems: [],
  query: "",
  selectedFilter: "items-distance",
  searchMode: "sprint",
  scrollPosition: 0,
  filterScrollPosition: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SEARCH_RESTAURANTS:
      return { ...state, restaurants: action.payload };

    case CLEAR_SEARCH:
      return {
        ...state,
        restaurants: action.payload,
        query: "",
        selectedFilter: "items-distance",
        searchMode: "sprint",
        scrollPosition: 0,
        filterScrollPosition: 0,
      };

    case SAVE_SEARCH_QUERY:
      return { ...state, query: action.payload };

    case SAVE_SELECTED_FILTER:
      return { ...state, selectedFilter: action.payload };

    case SAVE_SEARCH_MODE:
      return { ...state, searchMode: action.payload };

    case SAVE_SCROLL_POSITION:
      return { ...state, scrollPosition: action.payload };

    case SAVE_FILTER_SCROLL_POSITION:
      return { ...state, filterScrollPosition: action.payload };

    case SEARCH_ITEMS:
      return { ...state, searchItems: action.payload };

    case CLEAR_ITEM_SEARCH:
      return { ...state, searchItems: action.payload };
    default:
      return state;
  }
}
